
<template>
      <div class="model-controls" :style="{top:top}" v-if="!isHide">
      <div class="content">
        <div class="center-tip">
          <img src="img/3d-tip.png">
          <span>拖动进行3D查看</span>
        </div>
        <div class="bottom-tip">
          <span style="color: #939393;text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.3);">
            <img src="img/容器@1x.webp" alt="info">拖动进行3D查看</span>
          <span style="color: rgba(85, 201, 255, 0.8);"  @click="onReset">
            <img src="img/重新识别按钮@1x.webp" class="btn_reset" alt="重新识别">重新识别</span>
        </div>
      </div>
    </div>
</template>

<script setup>
import { defineProps ,ref,onMounted} from 'vue';
import { eventBus } from "@/utils/eventBus"
const props = defineProps({
  top: String,
})
const onReset = () => {
  eventBus.emit('message', 'reset')
}

const isHide = ref(false)
// 组件挂载时初始化
onMounted(() => {
  eventBus.on('model_hide', (value) => {
    console.log(value)
    isHide.value = value
  })

})
</script>

<style scoped lang="scss">
.model-controls {
  width: 100vw;
  height: 50vh;
  position: absolute;
  top: 45vh;
  z-index: 9;
  user-select: none;

  .content {
    flex: 1;
    width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    bottom: 20px;
    left: 0;
    right: 0;
    z-index: 99;

    .center-tip {
      min-height: 40px;
      width: 80%;
      //outline: 1px solid deepskyblue;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      user-select: none;
      pointer-events: none;
      gap: 1rem 0;

      img {
        padding-top: 40%;
        width: 100%;
        height: 100%;
      }

      span {
        text-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
        font-weight: 500;
        font-size: .8rem;
        color: #EDEDED;
      }
    }

    .bottom-tip {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 80%;
      //outline: 1px solid black;
      position: fixed;
      bottom: 30%;
      left: 50%;
      transform: translateX(-50%);

      span {
        font-size: .8rem;
      }

      span:nth-of-type(1) {
        visibility: hidden;
      }

      span:nth-of-type(2) {
        pointer-events: auto;
      }

      img {
        vertical-align: -4px;
      }

    }
  }
}
.btn_reset{
  pointer-events: auto;
}
</style>